import React, {
    useCallback, useEffect, useMemo, useContext
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useValidation } from '@xengage/gw-portals-validation-react'
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, DropdownSelectField, InputNumberField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from './SubjectsConditionsofQuoteComponent.module.scss';
import metadata from './SubjectsConditionsofQuoteComponent.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';

function SubjectsConditionsofQuoteComponent(props) {

const {
        data: SubjectsConditionsofQuoteVM,
        updateWizardData,
        submissionVM,
        SubjectsConditionsofQuotePath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);


   const addSubjectsConditionsofQuote = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            SubjectsConditionsofQuoteVM.value = SubjectsConditionsofQuoteVM.value || []

            const { _xCenter, _dtoName } = SubjectsConditionsofQuoteVM;

            const SubjectsConditionsofQuoteObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            SubjectsConditionsofQuoteVM.pushElement(
                SubjectsConditionsofQuoteObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, SubjectsConditionsofQuoteVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }
            
            SubjectsConditionsofQuoteVM.value.splice(index, 1);
            _.set(submissionVM.value, SubjectsConditionsofQuotePath, SubjectsConditionsofQuoteVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, SubjectsConditionsofQuotePath, SubjectsConditionsofQuoteVM?.value]
    );


const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

if (path === 'subconOfQuoFie') {
                const value = item.subconOfQuoFie ? item.subconOfQuoFie : '';
               
                    return (
                        <InputField
                            id={index + path}
                            className={styles.tableColumn}
                            path={path}
                            dataType="String"
                            onValueChange={(val, changedPath) => {
                                item.subconOfQuoFie = val;
                                handleValueChange(val, changedPath, index);
                            }}
                            value={value}
                        />
                    );
            }


}, [handleValueChange, translator, SubjectsConditionsofQuoteVM?.children, SubjectsConditionsofQuoteVM?.length, SubjectsConditionsofQuoteVM?.value]) 

const removeAssignmentTableRow = useCallback(
        (item, index) => (
                <Link
                    onClick={(e) => removeAssignmentItem(e, index, item)}
                    className={classNames(styles.deleteSection, styles.deleteRow)}
                >
                    <Icon icon="mi-delete" className={styles.deleteIcon} />
                </Link>
            ),
        [removeAssignmentItem]
    );

 const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`SubjectsConditionsofQuoteTable`]: {
            data: SubjectsConditionsofQuoteVM?.value,
        }
        
    }), [SubjectsConditionsofQuoteVM?.value])

const resolvers = {
        resolveCallbackMap: {
            addSubjectsConditionsofQuote,
            getTableCell,
            removeAssignmentTableRow
        }
    };

const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
                metadata.pageContent,
                SubjectsConditionsofQuoteVM,
                fieldId,
                fieldPath,
                overrideProps
            ),
        [SubjectsConditionsofQuoteVM, overrideProps]
    );

return (
        <ViewModelForm            
            uiProps={metadata.pageContent}
            model={SubjectsConditionsofQuoteVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

SubjectsConditionsofQuoteComponent.propTypes = wizardProps;
export default withRouter(SubjectsConditionsofQuoteComponent);
